var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.938 1.75H9.624V.328A.328.328 0 0 0 9.297 0H8.203a.328.328 0 0 0-.328.328V1.75h-3.5V.328A.328.328 0 0 0 4.047 0H2.953a.328.328 0 0 0-.328.328V1.75H1.312C.589 1.75 0 2.338 0 3.063v9.624C0 13.412.588 14 1.313 14h9.624c.725 0 1.313-.588 1.313-1.313V3.063c0-.725-.588-1.313-1.313-1.313Zm-.165 10.938H1.477a.164.164 0 0 1-.165-.165V4.375h9.626v8.148c0 .091-.074.165-.165.165ZM5.437 11.06l3.891-3.86a.328.328 0 0 0 .002-.464l-.616-.621a.328.328 0 0 0-.464-.002L5.213 9.127 4.007 7.91a.328.328 0 0 0-.464-.002l-.621.616a.328.328 0 0 0-.002.464l2.053 2.07c.128.129.335.13.464.002Z",
    fill: "#65707B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCheck);
export default ForwardRef;